module.exports = __webpack_public_path__ + "img/basketball_y.166c9e3f.svg";